import {
  Autocomplete,
  TextField,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { pl } from "date-fns/locale";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { API_URL } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import "../components/button.css";
import { addDays, isAfter } from "date-fns";
import Alerts from "../components/Alerts";
import { marginBottom } from "../App";
import Button from "@mui/material/Button";
import AddToPhotosSharpIcon from "@mui/icons-material/AddToPhotosSharp";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import DataCycle from "./DataCycle";

export default function CycleReminder({ user }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [weekDay, setWeekday] = useState("");
  const [repeat, setRepeat] = useState("");
  const [repeatOfDay, setRepeatOfDay] = useState("");
  const [value, setValue] = useState("");
  const [dayofweek, setDayofweek] = useState("");
  const { userData } = useContext(UserDataContext);
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [lastId, setLastId] = useState();

  const handleChangeInput = (event) => {
    setValue(event.target.value);
    setShowApiResponse(false);
  };
  const handleChange = (event) => {
    setWeekday(event.target.value);
    setShowApiResponse(false);
  };
  const handleChangeRepeat = (event) => {
    setRepeat(event.target.value);
    setShowApiResponse(false);
  };

  const [selectedDate, setSelectedDate] = useState(null);
  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };

  useEffect(() => {
    if (userData) {
      axios
        .get(API_URL + `/getactivities/${userData.cookie}`)
        .then((response) => {
          setOptions(response.data);
        })
        .catch((error) => {
          console.error("Błąd w pobieraniu danych:", error);
        });
    }
  }, [userData, inputValue, lastId]);
  useEffect(() => {
    if (userData) {
      axios
        .get(API_URL + `/getdayofweek/${userData.cookie}`)
        .then((response) => {
          setDayofweek(response.data);
        })
        .catch((error) => {
          console.error("Błąd w pobieraniu danych:", error);
        });
    }
  }, [userData, inputValue]);

  useEffect(() => {
    if (userData) {
      axios
        .get(API_URL + `/getrepeats/${userData.cookie}`)
        .then((response) => {
          setRepeatOfDay(response.data);
        })
        .catch((error) => {
          console.error("Błąd w pobieraniu danych:", error);
        });
    }
  }, [userData]);

  const handleAddNewOption = async () => {
    if (inputValue && !options.includes(inputValue)) {
      const obj = {
        userId: userData.userId,
        activitie: inputValue,
      };
      try {
        const response = await axios.post(
          API_URL + `/addactivities/${userData.cookie}`,
          obj
        );
        setShowApiResponse(true);
        if (response.data.error_msg === 559) {
          setApiResponse({
            title: "UWAGA",
            severity: "warning",
            info: "To zdarzenie już zostało wcześniej zapisane!",
          });
          setInputValue("");
        }
        if (response.data.error_msg === 200) {
          if (response.data.lastId > 0) {
            setLastId(response.data.lastId);
            setInputValue("");
          }
          setApiResponse({
            color: "text-success",
            info: "Zdarzenie dopisane!",
          });
        }
      } catch (error) {
        console.error("There was an error editing the user!", error);
      }
    }
  };
  const handleSubmit = async () => {
    if (selectedOption) {
      const formData = {
        selectedOption: selectedOption.id ? selectedOption.id : null,
        repeat: repeat,
        user: user,
        weekDay,
        selectedDate: selectedDate
          ? selectedDate.toISOString().split("T")[0]
          : null,
      };

      if (repeat === "") {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Nie wprowadzono ilości powtórzeń",
        });
        setShowApiResponse(true);
      } else if (weekDay === "") {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Nie wybrano dnia tygodnia",
        });
        setShowApiResponse(true);
      } else if (!selectedOption || !selectedOption.id) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Nie wybrano zadania cyklicznego_!",
        });
        setShowApiResponse(true);
      }
      if (repeat !== "" && weekDay > 0) {
        try {
          const response = await axios.post(
            API_URL + `/remindercycle/${userData.cookie}`,
            formData
          );

          if (response.data.error_msg === 200) {
            setApiResponse({
              title: "OK",
              severity: "success",
              info: "Zadanie dopisane!",
            });
          } else {
            setApiResponse({
              title: "UWAGA",
              severity: "error",
              info: "Nie udało się dopisać. Spróbuj za chwilę lub skontaktuj się z administratorem!",
            });
            setShowApiResponse(true);
          }
        } catch (error) {
          setApiResponse({
            title: "Błąd",
            severity: "error",
            info: "Błąd podczas edycji. Spróbuj za chwilę lub skontaktuj się z administratorem!",
          });
          setShowApiResponse(true);
        }
      }
    } else {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Nie wybrano zadania cyklicznego.!",
      });
      setShowApiResponse(true);
    }
  };
  const validateDate = (dateString) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regex)) {
      return null;
    }
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    if (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    ) {
      return dateString;
    } else {
      return null;
    }
  };
  return (
    <div>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <h5>Przypomnienia cykliczne.</h5>
      <h6>
        Wpisane przypomnienie zaczyna obowiązywać od następnego dnia i będzie
        dostępne w zakładce "PAMIĘTAJ!".
      </h6>
      <Row style={{ marginBottom }}>
        <Col md={5}>
          <Autocomplete
            value={selectedOption}
            onChange={(event, newValue) => {
              setSelectedOption(newValue);
              setShowApiResponse(false);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) =>
              setInputValue(newInputValue)
            }
            options={options}
            getOptionLabel={(option) => {
              if (typeof option === "string") {
                return option;
              }
              return option.activitie ? option.activitie : "";
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            freeSolo
            renderInput={(params) => (
              <TextField
                {...params}
                label="Wybierz lub wpisz i dodaj przypomnienie cykliczne"
                variant="outlined"
              />
            )}
          />
          <Button variant="contained" onClick={handleAddNewOption}>
            <AddToPhotosSharpIcon />
          </Button>
          Wpisz nowe przypomnienie, a następnie zatwierdź '+'
        </Col>
        <Col md={2}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="day-of-week">Dzień tygodnia</InputLabel>
            <Select
              labelId="day-of-week-label"
              value={weekDay}
              onChange={handleChange}
              label="Pora dnia"
            >
              {dayofweek &&
                dayofweek.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.day}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Col>
        <Col md={2}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="repeats-label">Ilość powtórzeń</InputLabel>
            <Select
              labelId="repeatId"
              value={repeat}
              onChange={handleChangeRepeat}
              label="Ilość powtórzeń"
            >
              {repeatOfDay &&
                repeatOfDay.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.repeats}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Col>

        <Col md={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={pl}>
            <DatePicker
              label="Do kiedy"
              value={selectedDate}
              onChange={handleDateChange}
              format="yyyy-MM-dd"
              slotProps={{ textField: { variant: "outlined" } }}
              minDate={addDays(new Date(), 1)}
            />
          </LocalizationProvider>
        </Col>
        <Col md={1}>
          <Button variant="contained" onClick={handleSubmit}>
            <CheckSharpIcon />
          </Button>
        </Col>
      </Row>
      <DataCycle user={user} />
    </div>
  );
}
